// Created on 2021-04-12
// Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential
// Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-12
import util from '@/lib/util'
import axios from 'axios'
import storage from './storage'

const asyncAPI = {
  downloadCustomers: () => {
    return new Promise((resolve, reject) => {
      const customers = []
      const actions = [
        // axios.get('https://dr.vilten.sk/csv/customers.csv')
        // axios.get('http://192.168.1.26:8003/sync/customers')
        axios.get('https://dr.vilten.sk/api/sync/customers')
      ]
      Promise.all(actions)
        .then(data => {
          ((data[0].data || "").toString().split("\n") || []).forEach(line => {
            const items = ((line || "").split("\t") || [])
            try {
              const item = {
                id: util.removeQ(items[0]),
                idOz: util.removeQ(items[1]),
                name: util.removeQ(items[2]),
                addName: util.removeQ(items[3]),
                street: util.removeQ(items[4]),
                city: util.removeQ(items[5]),
                psc: util.removeQ(items[6]),
                ico: util.removeQ(items[7]),
                dic: util.removeQ(items[8]),
                town: util.removeQ(items[9]),
                leader: util.removeQ(items[10]),
                email: util.removeQ(items[11]),
                phone: util.removeQ(items[12]),
                fax: util.removeQ(items[13]),
                orderedBy: util.removeQ(items[14]),
                payMethod: util.removeQ(items[15]),
                partnership: util.removeQ(items[16]),
                points: util.removeQ(items[17]),
                pzsCode: util.removeQ(items[18]),
                tcIdPhoenix: util.removeQ(items[19]),
                tcIdUnipharma: util.removeQ(items[20]),
                tcIdMedart: util.removeQ(items[21]),
                tcIdUnimed: util.removeQ(items[22]),
                networkName: util.removeQ(items[23]),
                associationName: util.removeQ(items[24])
              }
              if (util.removeQ(items[0]) && util.removeQ(items[1]) && util.removeQ(items[18]))
                customers.push(item)
            } catch (e) {
              console.trace(e)
            }
          })
          storage.setSettings('lastSyncTime', { value: Date.now()})
          resolve(customers)
        })
        .catch(reject)
    })
  },
  getLastUpdateTime: () => { console.log('getLastUpdateTime') },
  uploadAll: () => { console.log('uploadAll') },
}

export default asyncAPI